
import React from 'react';

export const InvesmartIcon: React.FC<{ className?: string }> = ({ className = "w-12 h-12" }) => (
  <svg viewBox="0 0 100 100" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="50" cy="50" r="48" fill="url(#logo-gradient)" />
    <g stroke="white" strokeWidth="8" strokeLinecap="round">
      <path d="M30 65 L45 50" opacity="0.8" />
      <path d="M30 45 L60 15" strokeWidth="10" />
      {/* Fixed: Corrected the path string by removing misplaced internal quotes that caused parsing errors */}
      <path d="M55 5 L65 15 L55 25" strokeWidth="6" strokeLinejoin="round" />
      <path d="M50 75 L75 50" strokeWidth="10" />
      <path d="M70 75 L75 70" opacity="0.8" />
    </g>
    <defs>
      <linearGradient id="logo-gradient" x1="0" y1="0" x2="100" y2="100" gradientUnits="userSpaceOnUse">
        <stop stopColor="#A78BFA" />
        <stop offset="1" stopColor="#7C3AED" />
      </linearGradient>
    </defs>
  </svg>
);

const Logo: React.FC<{ showTagline?: boolean; variant?: 'light' | 'dark' }> = ({ showTagline = true, variant = 'light' }) => {
  const textColor = variant === 'light' ? 'text-white' : 'text-[#0f0a24]';
  const brandColor = 'text-[#8b5cf6]';

  return (
    <div className="flex flex-col items-center">
      <div className="flex items-center gap-3">
        <InvesmartIcon className="w-10 h-10 md:w-14 md:h-14" />
        <span className={`text-3xl md:text-5xl font-bold tracking-tight ${brandColor}`}>Invesmart</span>
      </div>
      {showTagline && (
        <div className={`mt-2 text-[8px] md:text-[10px] font-bold uppercase tracking-[0.2em] ${textColor} flex gap-2 opacity-80`}>
          <span>Mentalidad</span>
          <span>|</span>
          <span>Finanzas</span>
          <span>|</span>
          <span>Inversiones</span>
          <span>|</span>
          <span>Crecimiento</span>
        </div>
      )}
    </div>
  );
};

export default Logo;
